type Viewport = 'desktop' | 'mobile';

class ViewportStore {
  public static get viewport(): Viewport {
    return window.innerWidth <= 900 ? 'mobile' : 'desktop';
  }
}

export default ViewportStore;
